import { Component, OnInit } from '@angular/core';
import { SearchService } from 'src/app/services/search.service';
import { ActivatedRoute, Params } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { forEach } from '@angular/router/src/utils/collection';
import { FundService } from 'src/app/services/fund.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  language = JSON.parse(localStorage.getItem('language'))

  checkMonth: Array<Object> = [
    {
      number: 1,
      name: 'ม.ค.'
    },
    {
      number: 2,
      name: 'ก.พ.'
    },
    {
      number: 3,
      name: 'มี.ค.'
    },
    {
      number: 4,
      name: 'เม.ย.'
    },
    {
      number: 5,
      name: 'พ.ค.'
    },
    {
      number: 6,
      name: 'มิ.ย.'
    },
    {
      number: 7,
      name: 'ก.ค.'
    },
    {
      number: 8,
      name: 'ส.ค.'
    },
    {
      number: 9,
      name: 'ก.ย.'
    },
    {
      number: 10,
      name: 'ต.ค.'
    },
    {
      number: 11,
      name: 'พ.ย.'
    },
    {
      number: 12,
      name: 'ธ.ค.'
    }
  ];
  FundList: any = [];
  FundListFilter: Array<any> = [];
  NewsList: any = [];
  AnnounceList: any = [];
  EarthUpdateList: any = [];
  FundRecomList: any = [];
  PromotionList: any = [];
  BenefitList: any = [];
  search: string;
  checkFund: boolean;
  checkNews: boolean;
  checkAnnounce: boolean;
  checkEarthUpdate: boolean;
  checkFundRecom: boolean;
  checkPromotion: boolean;
  checkBenefit: boolean;

  caretStatus = ''

  flag: any

  constructor(private _SearchService: SearchService, private route: ActivatedRoute, private _sanitizer: DomSanitizer, private _fundService: FundService) {
    this.route.params.subscribe(
      (params: Params) => {
        this.search = params['search'];
        this.Fund(this.search);
        this.News(this.search);
        this.Announce(this.search);
        this.EarthUpdate(this.search);
        this.FundRecom(this.search);
        this.Promotion(this.search);
        this.Benefit(this.search);
      }
    )
  }

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")
  }

  Fund(search) {
    this._SearchService.getFund(search).subscribe(response => {
      this.FundList  = response;
      this.checkFund = this.FundList[0].fundId ? true : false;
    });
    // this._fundService.get_fundByName(search).subscribe(response => {
    //   this.FundList = response
    //   this.checkFund = this.FundList[0].fundId ? true : false;
    // })
  }

  News(search) {
    this._SearchService.getNews(search).subscribe(response => {
      this.NewsList = response;
      this.checkNews = this.NewsList[0].newsid ? true : false;
    });
  }

  Announce(search) {
    this._SearchService.getAnnounce(search).subscribe(response => {
      this.AnnounceList = response;
      this.checkAnnounce = this.AnnounceList[0].announceid ? true : false;
    });
  }

  EarthUpdate(search) {
    this._SearchService.getEarthUpdate(search).subscribe(response => {
      this.EarthUpdateList = response;
      this.checkEarthUpdate = this.EarthUpdateList[0].title ? true : false;
    });
  }

  FundRecom(search) {
    this._SearchService.getFundRecom(search).subscribe(response => {
      this.FundRecomList = response;
      this.checkFundRecom = this.FundRecomList[0].title ? true : false;
    });
  }

  Promotion(search) {
    this._SearchService.getPromotion(search).subscribe(response => {
      this.PromotionList = response;
      this.checkPromotion = this.PromotionList[0].title ? true : false;
    });
  }

  Benefit(search) {
    this._SearchService.getBenefit(search).subscribe(response => {
      this.BenefitList = response;
      this.checkBenefit = this.BenefitList[0].title ? true : false;
    });
  }

  // Fund Function
  fixFloatDigit(value) {
    return parseFloat(value).toFixed(4);
  }

  isPositive(value) {
    if (Math.sign(value) == 1) {
      this.caretStatus = 'up'
      return true
    } else if (Math.sign(value) == -1 || Math.sign(value) == 0) {
      this.caretStatus = 'down'
      return false
    }
  }

  showOnlyValue(value) {
    return Math.abs(value)
  }

  setNumberFormat(value) {
    return parseFloat(value).toFixed(2);
  }

  changeFormatDate(date) {
    if (date != "") {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return day + ' ' + monthTh['name'] + ' ' + year;
    }
    else {
      return "";
    }

  }

  // News
  date_thai(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const year = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (day + ' ' + monthTh['name'] + ' ' + year);
  }

  getBackground(image) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${image})`);
  }

  date_thai_dd(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const year = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (day);
  }

  date_thai_mm(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const year = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (monthTh['name']);
  }

  date_thai_yy(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const year = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (year);
  }
}
